module.exports = __webpack_public_path__ + "static/media/image_37.3670be6c.png";